module.exports = __webpack_public_path__ + "static/media/clydeService.5d6ffd9f.png";